import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Check, Crown, Sparkles, Zap, Plus } from "lucide-react";

const tierIcon = { free: Sparkles, starter: Zap, pro: Crown, lifetime: Crown };

export default function PricingSection() {
  const [tiers, setTiers] = useState([]);
  const [botInvite, setBotInvite] = useState("");

  useEffect(() => {
    api.get("/subscriptions/tiers").then((r) => setTiers(r.data));
    api.get("/auth/bot-invite").then((r) => setBotInvite(r.data.url || ""));
  }, []);

  return (
    <section id="pricing" data-testid="pricing-section" className="relative max-w-7xl mx-auto px-6 md:px-12 py-28">
      <div className="text-center mb-16">
        <div className="overline mb-3">// 04 · PRICING</div>
        <h2 className="font-heading text-4xl md:text-5xl font-bold uppercase tracking-tight">
          Pick your <span className="text-brand-orange">battle plan</span>
        </h2>
        <p className="text-zinc-400 mt-4 max-w-2xl mx-auto">
          Add the bot for free, then upgrade per server when you're ready for more firepower.
          Each Discord server has its own subscription.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5">
        {tiers.map((t) => {
          const Icon = tierIcon[t.id] || Sparkles;
          const popular = t.id === "pro";
          return (
            <div key={t.id} className={`tactical-card p-6 flex flex-col relative ${popular ? "tier-popular" : ""}`} data-testid={`landing-tier-${t.id}`}>
              {popular && (
                <div className="absolute -top-3 left-6 px-3 py-1 bg-brand-orange text-black font-heading text-xs uppercase tracking-widest rounded">
                  MOST POPULAR
                </div>
              )}
              <div className="flex items-center gap-3 mb-4">
                <div className="p-2.5 bg-brand-orange/10 border border-brand-orange/40 rounded-lg">
                  <Icon className="w-5 h-5 text-brand-orange" />
                </div>
                <div className="font-heading text-2xl font-bold uppercase tracking-tight">{t.label}</div>
              </div>
              <div className="mb-5">
                <span className="font-mono-tabular text-5xl font-bold">${t.price}</span>
                <span className="text-zinc-500 text-sm ml-2">/{t.period}</span>
              </div>
              <ul className="space-y-2.5 mb-6 flex-1">
                {t.features.map((f) => (
                  <li key={f} className="flex items-start gap-2 text-sm text-zinc-300">
                    <Check className="w-4 h-4 text-brand-orange shrink-0 mt-0.5" />
                    {f}
                  </li>
                ))}
              </ul>
              {botInvite && (
                <a href={botInvite} target="_blank" rel="noreferrer" className={t.id === "free" ? "btn-secondary justify-center" : "btn-primary justify-center"} data-testid={`landing-cta-${t.id}`}>
                  <Plus className="w-4 h-4" /> {t.price === 0 ? "Start Free" : "Get Started"}
                </a>
              )}
            </div>
          );
        })}
      </div>

      <div className="mt-12 text-center text-zinc-500 font-mono-tabular text-xs">
        ⚠ PAYMENT WIRING IS PENDING · STRIPE INTEGRATION COMING NEXT
      </div>
    </section>
  );
}
